import { useRenderNotifier } from '@wui/common-library'
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { useUserData, UserFields } from '@/shared/composables/local-storage'
import { useLocalization } from '@/shared/composables/localization'
import { UserRoles } from '@/shared/types/router'
import { SUPPORT_SETTINGS_EQUIPMENT_LIST } from '@/shared/utils/constants'

import { setFunctionalKeysPropsResolver } from './lazy-route-props'

export const functionalKeysBeforeEnter = async (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const [{ useBlfStore }, { functionalKeysPropsFn }] = await Promise.all([
    import('@/features/blf'),
    import('./functionalKeysPropsFn'),
  ])
  setFunctionalKeysPropsResolver(functionalKeysPropsFn)

  const storeSettingsBlf = useBlfStore()
  const { fetch } = storeSettingsBlf
  const { t } = useLocalization()
  const { getField } = useUserData()
  const { notifyError } = useRenderNotifier()

  try {
    await fetch(to.params.mac as string)

    if (!to.meta) {
      to.meta = {}
    }
    to.meta.functionalKeysProps = functionalKeysPropsFn(to)
    next()
  } catch (e: unknown) {
    const mac = to.params.mac as string
    if (storeSettingsBlf.blf.has(mac)) {
      if (!to.meta) {
        to.meta = {}
      }
      to.meta.functionalKeysProps = functionalKeysPropsFn(to)
      next()
      return
    }

    const errorMessage = e instanceof Error ? e.message : t('common.unknownError')
    notifyError(errorMessage)
    const name = getField(UserFields.USER_ROLE) === UserRoles.SUPPORT ? SUPPORT_SETTINGS_EQUIPMENT_LIST : 'equipment'
    next({ name })
  }
}
